import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/33/thumb-landscape.jpg"

const Post33 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">LOUIS VUITTON／プティットノエ／13 x23 x13cm</span>   
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>幅広い世代に支持されている世界的ラグジュアリーブランドLOUIS VUITTON。長い歴史を持つブランドだけあって、バッグのラインナップの多さには圧倒されます。<br></br>上質なバッグを持っても嫌味のない30代の大人の女性にオススメしたいのは、日常的に使える使い勝手のいいバッグ。「ファッション性」と「使いやすさ」を両立させちゃいましょう！</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">        
        <div className="text-max-width">
          <h2>オンマイサイド</h2>
          <figure>
            <StaticImage src="../../images/posts/33/1.jpg" alt="" />
            <span className="text-center">相反するカラーで仕上げた外側ポケットは入れ子状</span>
          </figure>          
          <p>毎日の必需品やお仕事アイテムもスッポリ収まる大容量。グレインカーフレザーとルイヴィトンならではのモノグラム・キャンバスの組み合わせです。</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/33/2.png" alt="" />
          </figure>
          <p>レッドのカーフレザーのコンビだから、沈みがちな冬のコーデが華やぐこと間違いなし！</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/33/3.jpg" alt="" />
            <span className="text-center">31x26x10cm</span>
          </figure>
        </div>        
        <div className="text-max-width">
          <h2>モンテーニュBB</h2>
          <figure>
            <StaticImage src="../../images/posts/33/4.jpg" alt="" />
            <span className="text-center">シーン・季節を問わないデザインが人気</span>
          </figure>          
          <p>名前の由来はパリの「モンテーニュ通り」からだそう。世界中のラグジュアリーブランドが立ち並ぶ有名な通りです。<br></br>エレガントな柔らかなフォルムは女性らしく、同時に３WAYで使える機能性も両立。BBはモンテーニュシリーズで一番小さいですが、人気のサイズです。お財布やスマホ、メイクポーチなどの必需品は楽々収納できます。</p>
        <figure className="img-small">
          <StaticImage src="../../images/posts/33/5.jpg" alt="" />
        </figure>
        </div>
        <p>レストランでの贅沢ランチやホテルでアフタヌーンティーなど、いつもよりオシャレしたい場面にもぴったり！</p>
        <figure className="img-small">
          <StaticImage src="../../images/posts/33/6.jpg" alt="" />
          <span className="text-center">25x19x12cm</span>
        </figure>
        <Link to="https://laxus.co/app/pc/bags/louis_vuitton" className="view-all-button">
          ルイ・ヴィトンのバッグを見る
        </Link>
        <div className="text-max-width">
          <h2>オンザゴーGM</h2>
          <figure>
            <StaticImage src="../../images/posts/33/7.jpg" alt="" />
          </figure>
          <p>大きなモノグラムがインパクト大なオンザゴーGM 。収納力抜群で日常使いに最適です。大人の女性だからこそ、カジュアルスタイルにラグジュアリーバッグをプラスしてみて。</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/33/8.jpg" alt="" />
          </figure>
          <p>肩にもかけられるから、ちょっと荷物が重くなってもへっちゃら。子供とのお出かけや、旅行にも活躍しそうです。</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/33/9.jpg" alt="" />
            <span className="text-center">41x32x17cm</span>
          </figure>
        </div>
        <div className="text-max-width">
          <h2>トレンドの巾着型に高級感をプラス</h2>
          <figure>
            <StaticImage src="../../images/posts/33/10.jpg" alt="" />
            <span className="text-center">レザーの質感やゴールドの金具から漂うゴージャスな雰囲気</span>
          </figure>
          <p>ルイヴィトンの巾着型バッグの象徴「ノエ」のデザインを再解釈。さらに高級感が増して、大人のドレススタイルにもよく合います。</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/33/11.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/33/12.jpg" alt="" />
            <span className="text-center">13x23x13cm</span>
          </figure>
        </div>
        <div className="text-max-width">
          <h2>アルマ</h2>
          <figure>
            <StaticImage src="../../images/posts/33/13.jpg" alt="" />
          </figure>
          <p>アルマはルイヴィトンのロングセラーシリーズ。カジュアルからドレススタイルまでカバーできる万能さが人気の秘密です。<br></br>定番の「モノグラム」や「ダミエ」、エナメル素材の「ヴェルニ」、モノグラムの型押し「アンプラント」、レザーに特殊な型押し加工を施した「エピ」の5種類の展開です。</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/33/14.png" alt="" />
          </figure>
          <p>控えめなエピはどんなシーンでもOK！カラーで遊ぶのもよし、定番カラーを選んでシックに決めるもよし。コーデ次第で様々な場面で活躍するでしょう。</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/33/15.jpg" alt="" />
            <span className="text-center">30x23x14cm</span>
          </figure>
        </div>        
        <div className="text-two-cloumn">
          <h2>変化球で楽しむ名品</h2>
          <p>誰もが知るブランドLOUIS VUITTONだからこそ、あえて王道は外してみる…なんて、遊びのあるバッグ選びが楽しめるのがラクサスのいいところ！<br></br>どんなバッグが使いやすいかは人それぞれ違うはずです。みなさんが、日常がちょっと楽しくなるような、デザインと機能性を兼ね揃えたマイベストバッグに出会えますように！</p>
        </div>
        <Link to="https://laxus.co/app/pc/bags/louis_vuitton" className="view-all-button">
          ルイ・ヴィトンのバッグを見る
        </Link>        
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post33

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 33}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
